










import Component from 'vue-class-component';
import Vue from 'vue';
import LocationAutocomplete from '@/general/component/form/autocomplete/LocationAutocomplete.vue';
import DataLoggerAutocomplete
  from '@/general/component/form/autocomplete/DataLoggerAutcomplete.vue';
import NumberField from '@/general/component/NumberField.vue';
import { VModel } from 'vue-property-decorator';
import { MeterFormModel } from '@/context/meter/model/form/MeterFormModel';
import SensorAutocomplete from '@/general/component/form/autocomplete/SensorAutcomplete.vue';
import ModelAutocomplete from '@/general/component/form/autocomplete/ModelAutocomplete.vue';
import TextField from "@/general/component/form/input/TextInput.vue";
import DataLoggerVersionAutcomplete
  from "@/general/component/form/autocomplete/DataLoggerVersionAutcomplete.vue";
import DataLoggerVersionAutocomplete
  from "@/general/component/form/autocomplete/DataLoggerVersionAutocomplete.vue";

@Component({
  components: {
    DataLoggerVersionAutocomplete,
    TextField,
    ModelAutocomplete,
    SensorAutocomplete,
    NumberField,
    LocationAutocomplete,
    DataLoggerAutocomplete

  }
})
export default class MeterDeviceFormBase extends Vue {
  @VModel({ default: new MeterFormModel() }) model!: MeterFormModel;
}
